const STORE_KEY = 'TEST'

export const FETCH_TEST = `${STORE_KEY}/FETCH_TEST`
export const SET_PROBS = `${STORE_KEY}/SET_PROBS`
export const SET_OPTIONS = `${STORE_KEY}/SET_OPTIONS`
export const SET_ERROR = `${STORE_KEY}/SET_ERROR`
export const SET_TIMER = `${STORE_KEY}/SET_TIMER`
